/**
 * Bottom bar showing the total criteria weight and an "Add Criteria" button.
 */
import { FiPlus } from "react-icons/fi";
import { Button } from "newui/components/Button";

interface WeightSummaryProps {
	totalWeight: number;
	isWeightValid: boolean;
	canEdit: boolean;
	isAdding: boolean;
	isEditingAny: boolean;
	onStartAdd: () => void;
}

const getWeightColorClass = (totalWeight: number): string => {
	if (totalWeight === 100) return "text-green-600";
	if (totalWeight > 100) return "text-red-600";
	if (totalWeight > 0) return "text-amber-600";
	return "text-gray-400";
};

export const WeightSummary: React.FC<WeightSummaryProps> = ({
	totalWeight,
	isWeightValid,
	canEdit,
	isAdding,
	isEditingAny,
	onStartAdd,
}) => (
	<div className="flex items-center justify-between">
		<div className="flex items-center gap-3">
			{canEdit && !isAdding && (
				<Button
					btntype="secondary"
					onClick={onStartAdd}
					disabled={isEditingAny}
					data-testid="add-criterion-btn"
				>
					<FiPlus className="mr-1 inline" size={14} />
					Add Criteria
				</Button>
			)}
		</div>
		<div
			className={`text-sm font-medium ${getWeightColorClass(totalWeight)}`}
			data-testid="weight-summary"
		>
			Total weight: {totalWeight}%
			{!isWeightValid && (
				<span className="ml-1 text-xs">(must equal 100%)</span>
			)}
		</div>
	</div>
);
